export default "__VITE_ASSET__CSpev3X8__"